export default __webpack_public_path__ + "static/media/title-landing.9194ffd3.svg";